import { CandidateUploadConfig } from './candidate-upload.abstract.config';

export const candidateUploadConfig: CandidateUploadConfig = {
  privileges: {
    associate: {
      jobs_to_candidate: 'web:associate-jobs-to-candidate',
    },
  },
};
